import React from "react";
import BranchRequiredWrapper from "@/components/banners/BranchRequiredWrapper";
import TransactionTable from "./components/transaction/TransactionTable";
import { useTranslation } from "react-i18next";

const Transactions: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="container mx-auto px-4 py-2">
      <BranchRequiredWrapper>
        <h1 className="mb-4 text-2xl font-bold">{t("back.management.transaction.title")}</h1>
        <TransactionTable />
      </BranchRequiredWrapper>
    </div>
  );
};

export default Transactions;